import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface ArchitectureEngineeringDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const ArchitectureEngineeringDescription: React.FC<ArchitectureEngineeringDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [architectureEngineeringDescription, set_architectureEngineeringDescription] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Architecture, Engineering']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Architecture, Engineering': [v, b.values?.['Site Work']?.['Architecture, Engineering']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={architectureEngineeringDescription}
                />
            ) : (
                <TextBox
                    value={architectureEngineeringDescription}
                    onChange={(value) => set_architectureEngineeringDescription(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
